import axios from 'axios';

const host = () => process.env.REACT_APP_BACKEND_HOST;

// Cada app se consulta por su propio prefijo, como el resto del CS: el backend
// apunta el cliente de Parse a watch o tablet según la ruta.
const PREFIX = {
    watch: '/wearer/subscriptionInsights',
    tablet: '/tablet/subscriptionInsights',
};

async function get(token, project, path, refresh) {
    const response = await axios.get(`${host()}${PREFIX[project]}${path}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { refresh: refresh ? 'true' : undefined },
    });
    return response.data.data;
}

export function getOverview(token, project, { refresh = false } = {}) {
    return get(token, project, '/overview', refresh);
}

/** KPIs de un operador: movimiento y churn, salud del cobro, suspendidas y job de reintentos. */
export function getOperatorKpis(token, project, operator, { refresh = false } = {}) {
    const path = `/operators/${encodeURIComponent(operator.toLowerCase())}/kpis`;
    return get(token, project, path, refresh);
}

/** Una página de suscripciones de un operador, con filtro de estado y búsqueda. */
export async function getOperatorSubscriptions(
    token,
    project,
    operator,
    { status = '', payment = '', search = '', page = 1, pageSize = 25 } = {}
) {
    const path = `/operators/${encodeURIComponent(operator.toLowerCase())}/subscriptions`;
    const response = await axios.get(`${host()}${PREFIX[project]}${path}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
            status: status || undefined,
            payment: payment || undefined,
            search: search || undefined,
            page,
            pageSize,
        },
    });
    return response.data.data;
}
